import '../Home/Home.css';
import { Button, Label, Input, FormGroup, Form } from 'reactstrap';
import React, { Component } from "react";
import withNavigateHook from '../../myRoutes';
import axios from 'axios';
import Select from 'react-select';
//import { parse } from 'next/dist/build/swc/generated-native';

class Mygroups extends React.Component {
    constructor(props) {
        super(props);
        const today = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric" });
        const dateWithoutSecond = new Date().toLocaleDateString('en-uk', { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: '2-digit', minute: '2-digit' });
        const dateTime = new Date().toLocaleDateString('en-uk', { hour: '2-digit', minute: '2-digit' });
        this.state = {
            date: today,
            dateWithoutSecond: dateWithoutSecond,
            dateTime: dateTime,
            startdate: "",// new Date(),
            enddate: "", // new Date(),
            selectedDate: new Date(),
            userRole: "",
            firstname: "",
            lastname: "",
            db: "",
            allOrgs: "",
            allusers: "",
            email: "",
            userdata: [],

        }
    }

    componentDidMount = () => {
        this.loadAllOrgs();
        this.loadAllUsers();
        // this.setState({
        //     db: this.props.location.state.db, firstname: this.props.location.state.firstname,
        //     email: this.props.location.state.email, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
        // });
        // console.log(this.props.location.state.userdata)

    }
   
    componentDidUpdate() {
        window.onpopstate = e => {
            if (window.confirm('Are you sure you want to log out?')) {
                this.appLogout();
            } else {
                this.props.navigate('/mygroups', {
                    state: {
                        db: this.state.db, email: this.state.email,
                        firstname: this.state.firstname, userRole: this.props.location.state.userRole, memberstatus: this.props.location.state.memberstatus
                    }
                });
            }
        }
    }



    getOrgsName = (id) => {
        // console.log('---->>>'+this.state.allOrgs.length)
        let orgname = ""
        for (let i = 0; i < this.state.allOrgs.length; i++) {
            if (id === this.state.allOrgs[i].id) {
                orgname = this.state.allOrgs[i].name
                //  console.log('------'+orgname)
                break;
            }
        }
        return orgname;
    }

    loadAllOrgs = async (e) => {
        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "businessname": this.props.location.state.db }
        }
        // const url = "http://localhost/kimvuka-php/api/getGroupAllmemberships.php";
        const url = "https://testmembership.bktsystems.com/api/getAllOrgs.php";
        const response = await axios.get(url, config);
        //console.log(response.data);
        this.setState({ allOrgs: response.data });
    }

    loadAllUsers = async () => {

        let config = {
            headers: { 'Accept': 'application/json' },
            params: { "businessname": this.props.location.state.db }
        }
        // const url = "http://localhost/kimvuka-php/api/getGroupAllmemberships.php";
        const url = "https://testmembership.bktsystems.com/api/getAllusers.php";
        const response = await axios.get(url, config);
        //  console.log(response.data);
        this.setState({ allusers: response.data });

    }
    goTomenu = async (id, db) => {
        let firsName = "";
        let userole = "";

        for (let j = 0; j < this.state.allusers.length; j++) {
            if ((id === this.state.allusers[j].orgid) && (this.props.location.state.email === this.state.allusers[j].emailaddress)) {
                // console.log(this.state.allusers[j].firstname)
                this.firsName = this.state.allusers[j].firstname
                this.userole = this.state.allusers[j].role
                this.setState({
                    firstname: this.state.allusers[j].firstname, email: this.state.allusers[j].emailaddress,
                    userRole: this.state.allusers[j].role
                })
                break

            }
        }

        let mconfig = {
            headers: { 'Accept': 'application/json' },
            params: { "businessname": db, "email": this.props.location.state.email }
        }
        //const murl = "http://localhost/kimvuka-php/api/checkMemberStatus.php";
        const url = "https://testmembership.bktsystems.com/api/checkMemberStatus.php";
        const mresponse = await axios.get(url, mconfig)

        this.props.navigate('/menu', {
            state: {
                db: db, email: this.props.location.state.email,
                firstname: this.firsName, userRole: this.userole,
                memberstatus: mresponse.data
            }
        });
    }

    appLogout = (e) => {
        //e.preventDefault();
        this.props.navigate('/', { replace: true, state: { db: '', email: '', firstname: '' } });
    }

    render() {
        return (
            <div className="mainDivHome" style={{ paddingTop: "25vh", border: '2px solid rgb(89, 100, 95)', borderRadius:"10px" }}>
                <div style={{ paddingTop: "10px", textAlign: "center" }}>
                    <span style={{ fontStyle: "italic" }} className="businessname"><h4>{this.props.location.state.db}</h4></span>
                    <span style={{ fontSize: "16px", fontStyle: "italic" }}><label>Welcome {this.props.location.state.firstname}</label></span>
                    <span style={{ fontSize: "16px", fontStyle: "italic" }}><label>, today is {this.state.date}</label></span>
                </div>
                <div>
                    <div style={{ fontStyle: "italic", textAlign: "center", paddingTop: "5px" }}><Label> <h4>CHOOSE GROUP</h4></Label></div>
                </div>
                <div style={{ paddingBottom: "10px" }}>
                    {this.props.location.state.userdata.map((item, index) => {
                        if (item.orgid !== "") {
                            return (<div key={item.id} style={{
                                height: "40px", color: "white", borderBottom: "1px solid white", borderRadius: "5px", fontStyle: "italic",
                                fontSize: "16px", paddingTop: "10px", backgroundColor: "black", textAlign: "center", fontWeight: "bold", borderTop: "1px solid white", cursor: "pointer"
                            }}
                                onClick={() => this.goTomenu(item.orgid, this.getOrgsName(item.orgid))}
                            >{'>>> ' + this.getOrgsName(item.orgid) + ' >>>'}</div>)
                        }

                    })}

                    <div id="clearDiv" style={{ alignItems: "center", paddingTop: "10px", float: "center" }}>
                        <Button style={{ paddingLeft: "5px", width: "100%", background: "none", border: "none", backgroundColor: "black", fontWeight: "bold", fontSize: "18px", color: "#ff7400", fontStyle: "italic" }} text="Logout" onClick={this.appLogout}>Logout</Button>
                    </div>
                </div>
            </div>)
    };

}
export default withNavigateHook(Mygroups)